import type { ActivityType } from '@/data/idp/interfaces';
import type { Plan } from '@/data/idp/plans/interfaces';
import type { Course, CourseTypes } from '@/models/catalog/course';
import type { Skill } from '@/models/taxonomy/skills';

export enum RecommendationPlanIds {
  Duration = 'duration',
  Feedback = 'feedback',
  NewFeedback = 'newFeedback',
  ProcessingFeedback = 'processingFeedback',
  RecommendationReview = 'recommendationReview',
  SkillSelection = 'skillSelection',
}

export enum ProcessingStatus {
  Fail = 'fail',
  Pending = 'pending',
  Success = 'success',
}

export enum ActivityCategory {
  Courses = 'courses',
  Practicals = 'practicals',
  Socials = 'socials',
  Work = 'work',
}

export interface RecommendedPlanActivity {
  id: string;
  name: string;
  reason: string;
  duration: { type: string; unit: number };
  activity_type: ActivityType;
  activity_category: ActivityCategory;
  course_type: CourseTypes;
}

export interface ProfileBasedRecommendation {
  id: string;
  current_step: RecommendationPlanIds;
  developing_skills: Skill[];
  processing_status: ProcessingStatus;
  recommended_activities: RecommendedPlanActivity[];
  recommended_plan_description: string;
  duration_in_months: number;
  plan: Partial<Plan>;
  completed_at: string;
  discarded_at: string;
}

export interface useCompleteProfileBasedRecommendationParams {
  activities: SelectedActivityPayload[];
  currentStep: RecommendationPlanIds;
  id: string;
}

export interface SelectedActivityPayload {
  id: RecommendedPlanActivity['id'];
  selected_course: Course | null;
}
